import axios from "axios";
import { defineStore } from "pinia";
import swal from "sweetalert";
import {HandleErrorResponse} from "~/javascripts/utils.js"
import facebookTracker from "@/javascripts/tracker/facebook_tracker";

const designSessionStorageKey = "design_cache";

// 模式
const normalModeKey       = "normal";
const toShareModeKey      = "to_share";
const shareInfoModeKey    = "share_info"
const shareModeKey        = "share";
const shoppingCartModeKey = "shopping_cart";

export const useDesignLabStore = defineStore("designLabStore", {
  state: () => {
    return {
      // user資訊
      user: {
        id: null,
      },

      // design資訊
      design: {
        id: null,
        variant_id: null,
        color: { name: null, code: null },
        title: null,
        sku: null,
        description: null,
        share_url: null,
        slug: null,
        name: null,
        moks: [],
        is_published: false,
      },

      // 原desgin 各面maxHegiht
      originalDesignAreas: [],

      lineItems: [],

      // 文字資訊
      textInfo: {
        default_font_color_idx: null,
        default_font_family_idx: null,
        font_colors: [],
        font_familys: [],
      },

      // 產品顏色資料
      specColors: [
        {
          value: null,
          description: null,
          variant_id: null,
          moks: [],
          sizes: [],
        },
      ],

      // 素材顏色資料(TODO:目前暫定為TextColor)
      moduleColors: [],

      // 估價資料
      checkInfo: {
        designAreaPrices: [],
        amountPriceInfo: [],
        price: null,
        priceWithAreas: null,
      },


      // 更換產品相關變數
        //目前所選的商品分類
        currentProductCategorySlug: null,

        //產品與種類
        productCategories: [],

        //目前更換產品列表顯示的產品
        categoryProducts: [],

        //更換產品進行中
        productChanging: false,

        // 搜尋產品關鍵字
        productSearch: "",

        // 熱門商品列表slug
        hotProductCategorySlug: "hot",

        clickElement:null,
        noClickBlock:true,
      // design lab 操作時的canvas objects cache
      canvasObjsCache: {},

      // 綁定覆蓋design或者是新建立一個design的選項
      designReplaceRadioCache: "1",

      // 顯示目前design的名稱
      designNameCache: "",

      // 紀錄目前active的setup component名稱
      activeSetupName: "",

      // 設計稿確認(DesignCheck)的預覽圖片
      previewImages: [""],

      // 預覽區域的side id
      // 用來render預覽圖片用
      previewerSideIds: [],

      //
      setupPaths: [],

      //
      currentPathIdx: 0,

      //
      inactiveSetupFunc: null,

      // 此欄位用於判斷design lab是否正在設定中
      designLabLoading: true,

      // 此欄位用於判斷是否setup區塊正在使用API讀取資料
      loading: false,

      // 此欄位用來判斷是否正在讀取初始化的design lab資料
      // 讀取資料時會disable design lab的提交按鈕
      isIniting: false,

      // deisgn lab模式
      // normal模式:   一般模式
      // share模式:    透過分享連結的加入設計的模式
      // to_share模式: 使用者分享自己連結的模式
      mode: normalModeKey,

      // desktop顯示setup區塊時，
      // 使用此欄位將desktop工具列等隱藏起來
      desktopSaveMode: false,

      // 離開design lab頁面要提醒客戶
      notifyWhenLeave: false,

      // 用於判斷是否要重新讀取設計搞確認的資料
      canGetCheckInfo: true,

      // design是否改變
      designDirty: false,

      //目前是否有cache design
      isDesignCache: false,
    };
  },
  getters: {
    isDesignLabLoading() {
      return this.designLabLoading === true;
    },
    currentProductCategoryName() {
      if(this.currentProductCategorySlug === this.hotProductCategorySlug){
        return "熱門產品";
      }

      return this.productCategories.find(e => e.slug === this.currentProductCategorySlug)?.name;
    },
    isNormalMode() {
      return this.mode === normalModeKey;
    },
    isToShareMode() {
      return this.mode === toShareModeKey;
    },
    isShareInfoMode() {
      return this.mode === shareInfoModeKey;
    },
    isShareMode() {
      return this.mode === shareModeKey;
    },
    isShoppingCartMode() {
      return this.mode === shoppingCartModeKey;
    },
    userIsLogin() {
      return this.user.id !== null;
    },
    isNewDesign() {
      return this.design.id === null;
    },
    designNeedReplace() {
      return this.designReplaceRadioCache === "2";
    },
    validDesignName() {
      return this.design.name && this.design.name.length != 0;
    },
    showRestoreDesignBtn() {
      return this.userIsLogin && this.isNewDesign && this.isDesignCache;
    },
    colorBadgeStyle() {
      // TODO 整合到scss
      const isWhiteColor = this.design.color.code === "#ffffff";
      return {
        color: isWhiteColor ? "#666666" : "#ffffff",
        border: isWhiteColor ? "1px solid #d1d1d1" : "none",
        "background-color": this.design.color.code,
      };
    },
    extraPriceAmountPriceInfo() {
      return this.checkInfo.amountPriceInfo.filter((info) => info.extraPrice);
    },
  },
  actions: {
    async getMaterialCategories() {
      try {
        const resp = await axios.get(`/api/material_categories/get_material_categories`);
        const materialCategories = resp.data.material_categories;
        return materialCategories;
      } catch(err) {
        console.log(err);
        return [];
      }
    },

    async getMaterials(categoryName = null, materialsSearch = null) {
      let api = '/api/materials/get_materials'
      if(categoryName) api = api + `?category_name=${categoryName}`

      if(materialsSearch) api = api + `?materials_search=${materialsSearch}`

      try {
        const resp = await axios.get(api);
        const result = resp.data.search_result;
        return result;
      } catch(err) {
        console.log(err);
        return [];
      }
    },

    setNormalPaths() {
      let checkSetfunc = ()=>{
        this.setNormalPaths();
      };

      this.setupPaths = [
        {name: "DesignCheck", setFunc: checkSetfunc},
        {name: "DesignName"},
        {name: "DesignShare"}
      ];
    },
    setShoppingCartModePaths() {
      this.setNormalPaths();

      // MK23102502
      // 若是修改後並儲存的design，購買時不用另外儲存
      if (this.design.id && !this.designDirty) {
        this.setupPaths.splice(1, 1);
      }

      this.setupPaths.splice(1, 0, {name: "DesignShoppingCart"});
      this.setupPaths[this.setupPaths.length-1] = {name: "NULL", setFunc: this.addToCart}
    },
    goToShoppingCartModeSetup(){
      this.setShoppingCartModePaths();
      this.goToNextSetup();
    },
    checkLineItems() {
      // no size options
      if (this.lineItems.length === 0) {
        swal({text: "無尺寸選擇", dangerMode: true});
        return;
      }

      // no qty
      let totalQty = 0;
      this.lineItems.forEach(e => totalQty = totalQty + e.quantity)
      if (totalQty === 0) {
        swal({text: "無尺寸選擇", dangerMode: true});
        return;
      }

      return true;
    },
    async addToCart() {
      if (!this.checkLineItems) {
        reutrn;
      }

      const items = [];
      this.lineItems.forEach((item) => {
        if (item.quantity == 0) {
          return;
        }

        items.push({
          size_id:  item.size_id, // 你需要從你的資料中取得 variant_id
          size:     item.size,       // 使用商品的尺寸作為 size
          quantity: item.quantity,   // 使用商品的 quantity 作為 quantity
        });
      });

      axios.post("/api/carts/add_to_cart", {
        data: {
          design_id:  this.design.id,
          line_items: items,
        }
      })
      .then(() => {
        // Facebook Pixel: AddToCart
        facebookTracker.trackAddToCart({
          content_ids: [this.design.sku],
          value: this.checkInfo.price,
        });
        
        this.gotoURLNoNotify('/orders/checkout');
      })
      .catch((e) => {
        this.processAPICatchError(e, () => {
          window.location = "/";
        });
      });
    },
    async sendRequestWithLoading(processer) {
      this.loading = true;
      const err = await processer();
      setTimeout(() => {
        this.loading = false;
      }, "200");

      return err;
    },
    async init(designID, mode = normalModeKey, designVgId) {
      this.isIniting = true;
      this.mode      = mode;

      // 抓取初始資料
      let InfoApi = `new?v_id=${designVgId}`
      if (this.isShareMode || this.isShareInfoMode) {
        InfoApi = `${designID}/share`;
      }
      else if (designID) {
        InfoApi = `${designID}/edit`;
      }
      try {
        const resp = await axios.get(`/api/designs/${InfoApi}`);
        this.updateCoreData(resp.data);
      } catch (e) {
        this.processAPICatchError(e, () => {
          window.location = "/";
        });
        return;
      }

      // 重設預覽圖資料
      this.resetPreviewImages();

      // 設定目前是否有design cache
      this.isDesignCache = !!this.getDesignCache();

      // TODO: 手機版不work，可能要用另外一種方式處理
      window.addEventListener("beforeunload", this.notifyWhenLeaveProc);
      window.addEventListener('click', this.notifyWhenLeaveClickProc);

      // 設定setup paths
      this.setNormalPaths();

      this.isIniting = false;

      if (this.isToShareMode) {
        this.activeSetup(true, this.setupPaths.length - 1);
      }
      else if (this.isShareMode) {
        // 透過分享的design, 與自建的design操作有所不同
        // 當作新的design來處理且包含參考的design資
        this.design.id = null;
        this.design.name = null;
        this.clearDesignCache();

        this.inactiveSetupFunc = () => {
          this.notifyWhenLeave = false;
          this.noClickBlock=false;
          window.history.go(-1);
          return;
        }

        this.setupPaths = [
          {name: "DesignName"},
          {name: "DesignShare", setFunc: ()=>{
            this.setupPaths = [{name: "DesignShare"}];
            this.inactiveSetupFunc = () => {
              this.setNormalPaths();
              this.inactiveSetupFunc = null;
              this.inactiveSetup();
            };
          }}
        ]

        this.activeSetup(true, null, `/design_lab?d_slug=${this.design.slug}`);
      }
      else if (this.isShoppingCartMode) {
        this.setShoppingCartModePaths();
        this.activeSetup(true, 1);
      }
      else if (this.isShareInfoMode) {
        this.setupPaths = [{name: "DesignInfo"}];
        this.activeSetup(true, null);
      }
    },
    async getCategroyProducts(slug) {
      let error = false;

      try {
        const resp = await axios.get(`/api/products?ca_slug=${slug}`);
        this.categoryProducts = resp.data.products;
      } catch (e) {
        error = true;
        this.processAPICatchError(e);
      }

      return error;
    },
    async getDesignLabInfo(api) {
      let error = false;

      try {
        let endpoint = "new"
        infoQuerys.push(`v_id=${designVgId}`);

        if (designID) {
          infoQuerys.pop();
        }

        const resp = await axios.get(`/api/designs/${endpoint}?${infoQuerys.join("&")}`);
        this.updateCoreData(resp.data);
      } catch (e) {
        error = true;
        this.processAPICatchError(e, () => {
          window.location = "/";
        });
      }

      return error;
    },
    async getProduct(slug) {
      let resp = null;
      try {
        resp = await axios.get(`/api/products/${slug}`);
      } catch (e) {
        this.processAPICatchError(e);
        return [null, true]
      }

      return [resp.data.product, false];
    },
    async changeProduct(variantGroupID) {
      const resp = await axios.get(`/api/designs/new?v_id=${variantGroupID}`);
      this.updateCoreData(resp.data);
      this.lineItems = [];
    },
    // TODO: 需要考慮verison的變化
    async restoreDesignByCache() {
      const designCacheJson = sessionStorage.getItem(designSessionStorageKey);

      if (designCacheJson) {
        let designCache = JSON.parse(designCacheJson);
        try {
          const resp = await axios.get(
            `/api/designs/new?v_id=${designCache.variant_id}`
          );
          let data = resp.data;

          designCache.title = data.design.title;
          designCache.sku = data.design.sku;
          designCache.mok_id = data.design.mok_id;

          data.design = designCache;
          this.updateCoreData(data);
        } catch (e) {
          this.processAPICatchError(e);
        }

        this.clearDesignCache();
      }
    },
    async getDesignCheckInfo(setFromCanvas=true) {
      // 更新design值
      // 有些component可能第一次進去design lab就要取圖，
      // 此參數防止Canvas還未設定好時就去更新的情況
      if (setFromCanvas) {
        this.setDesignByCanvasObjsCache();
      }

      // 是否design有改變
      if (!this.canGetCheckInfo) return;
      this.canGetCheckInfo = false;

      // 移除除掉之前預覽的圖片
      this.resetPreviewImages();

      // 抓取估算金額資料
      const data = await this.sendRequestWithLoading(async () => {
        try {
          const resp = await axios.post("/api/designs/get_design_check_info", {
            design: this.design,
          });
          return resp.data.design_check_info;
        } catch (e) {
          this.processAPICatchError(e, ()=>{
            window.location.href = "/";
          });
        }
      });
      this.checkInfo = data;

      if(this.lineItems.length === 0) {
        this.lineItems = this.checkInfo.design_variants.map(item => ({
          size_id:   item.size_id,
          size:      item.size,
          quantity:  0,
          surcharge: item.surcharge
        }));
      }
    
      // 抓取與底圖合成的預覽圖片
      const previewSideIds = this.design.moks.map(e=>e.side_id).concat(this.previewerSideIds);
      for(let idx = 0; idx < previewSideIds.length; idx += 1) {
        try{
          const response = await axios({
            method: "post",
            url: "/api/designs/preview",
            data: { design: this.design, side_id: previewSideIds[idx] },
            responseType: "blob",
          })

          const urlCreator = window.URL || window.webkitURL;
          this.previewImages[idx] = urlCreator.createObjectURL(
            new Blob([response.data], { type: "image/png" })
          );
        }
        catch (e) {
          console.log(e);
        }
      }

      return data;
    },
    async saveDesign() {
      // MK23103111
      // 取消跳出詢問你的編輯不會被存起來的詢問
      // TODO: 儲存失敗後的處理
      this.notifyWhenLeave = false;
      this.noClickBlock=false;
      const err = await this.sendRequestWithLoading(async () => {
        let err = null;
        let oldDesignID = this.design.id;

        try {
          // 更新design資訊
          this.setDesignByCanvasObjsCache();

          // 覆蓋原本design時，id為null
          if (!this.isNewDesign && this.designNeedReplace) {
            this.design.id = null;
          }

          const resp = await axios.post("/api/designs/save", {
            design: this.design,
          });

          // save完之後會回傳儲存後的design資料和user資料
          // 所以需要再更新一次
          this.updateCoreData(resp.data);

          // 將url改變為edit design的url
          if (oldDesignID !== this.design.id) {
            history.replaceState(
              {},
              null,
              `/design_lab/${this.design.id}/edit`
            );
          }

          this.canGetCheckInfo = false;
          this.designDirty     = false;
        } catch (e) {
          err = e;
          this.processAPICatchError(e);

          // 若執行的是覆蓋原本design的話，需要將原本design的id改回去
          this.design.id = oldDesignID;

          // 預設為"覆蓋原本design"選項
          this.designReplaceRadioCache = "1";
        }

        return err;
      });

      return err;
    },
    updateCoreData(data) {
      this.design = data.design;
      this.originalDesignAreas = this.design.moks.map(({ title, original_max_height }) => ({ title, originalMaxHeight: original_max_height }));
      this.user = data.user;
      this.designNameCache = this.design.name;
      this.specColors = data.spec_colors;
      this.textInfo = data.text_info;
      this.moduleColors = data.text_info.font_colors; // TODO:待確定colors
      this.previewerSideIds = data.previewer_side_ids;

      this.productCategories          = data.product_categories;
      this.currentProductCategorySlug = this.productCategories[0]?.slug || null;
    },
    cacheDesign() {
      this.setDesignByCanvasObjsCache();
      sessionStorage.setItem(
        designSessionStorageKey,
        JSON.stringify(this.design)
      );
      this.isDesignCache = true;
    },
    clearDesignCache() {
      sessionStorage.removeItem(designSessionStorageKey);
      this.isDesignCache = false;
    },
    getDesignCache() {
      return sessionStorage.getItem(designSessionStorageKey);
    },
    setDesignByCanvasObjsCache() {
      this.design.moks.forEach((mok) => {
        // TODO 使用site id
        const cacheCanvasObj = this.canvasObjsCache[mok.title];

        // 沒找到相對的區域
        if (!cacheCanvasObj) {
          // ...
          return;
        }

        // 設定center
        mok.center = {
          top: cacheCanvasObj.center.top,
          left: cacheCanvasObj.center.left,
        };

        // 設定max_height
        mok.max_height = cacheCanvasObj.maxHeight;

        // 設定areas
        mok.areas = [];
        console.log("areaObj")
        cacheCanvasObj.areaObjs.forEach((areaObj) => {
          console.log(areaObj)
          mok.areas.push({
            title: areaObj.title,
            width: areaObj.width,
            height: areaObj.height,
            top: areaObj.top,
            left: areaObj.left,
            limit: areaObj.limitArea !== undefined ? areaObj.limitArea : areaObj.limit,
          });
        });
        console.log("areaObj2")
        // 設定mok designs
        mok.designs = [];
        cacheCanvasObj.designObjs.forEach((designObj) => {
          // textColor或imageColors是design lab前端執行loadImage時所產生的欄位
          // 若其它設計區域未讀取到design lab時，不會有這些欄位，若沒有去讀取color或colors時，會導致文字顏色不正確
          const color = designObj.textColor ? designObj.textColor : designObj.color;
          const colors = designObj.imageColors ? designObj.imageColors : designObj.colors;

          mok.designs.push({
            // design的類型: 圖片或文字
            design_type: designObj.design_type,

            // 圖片的url或文字的url
            // 修改存在的design時，若未去修改某個區域，那個區域的designObj就不會有src屬性
            // 因為圖片沒有讀取就不會設定src屬性
            image_url: designObj.src || designObj.image_url,

            // 圖片類型專屬屬性，文字並不會實際儲存圖片
            image_id: designObj.image_id, // 圖片ID

            // 文字類型專屬屬性
            text: designObj.text, // 文字
            font_family: designObj.font_family, // 字型
            color: color, // 文字顏色
            // 垂直文字專屬屬性
            letter_spacing: designObj.letter_spacing,

            // module類型專屬屬性
            colors: colors,

            // 旋轉角度
            angle: designObj.angle,

            // design的位置和大小值
            top: designObj.top,
            left: designObj.left,
            imageWidth: designObj.imageWidth,
            imageHeight: designObj.imageHeight,

            // design邊框的位置和圖片大小值
            bound: {
              top: designObj.bound.top,
              left: designObj.bound.left,
              width: designObj.bound.width,
              height: designObj.bound.height,
            },
            boundWidthCm: designObj.boundWidthCm,
            boundHegihtCm: designObj.boundHeightCm,
          });
        });
      });
    },
    setDesignLabLoading(loading) {
      if(!loading) {
        setTimeout(() => {
          this.designLabLoading = loading;
        }, 150);
      } else {
        this.designLabLoading = loading;
      }
    },
    getSetupNameFromPath(path) {
      if(!path) {
        return null;
      }

      if (path.setFunc) {
        path.setFunc();
      }

      let setupName = path.name;

      return setupName
    },
    goToSetup(idx) {
      let path      = this.setupPaths[idx];
      let setupName = this.getSetupNameFromPath(path);

      if (!setupName) {
        return;
      }

      let regetIdx = this.setupPaths.findIndex(path => path.name == setupName);
      if (!regetIdx === -1) {
        return;
      }

      this.currentPathIdx  = regetIdx;
      this.activeSetupName = setupName;
    },
    goToNextSetup() {
      this.goToSetup(this.currentPathIdx + 1);
    },
    goToPreviousSetup() {
      this.goToSetup(this.currentPathIdx -1);
    },
    activeSetup(desktopAction, idx, loginRedirect=null) {
      // 其它步驟的使用者登入判斷交給各個setup component來處理
      if (!this.userIsLogin) {
        this.cacheDesign();

        // 有可能設計有改變, 但是不要讓使用者登入時還會跳入提醒設計改變的alert
        this.notifyWhenLeave = false;
        this.noClickBlock=false;

        let redirectToPath = "/design_lab";
        if (loginRedirect) {
          redirectToPath = loginRedirect;
        }

        // TODO: 整合url
        window.location = `/users/sign_in?redirect_to=${encodeURIComponent(
          redirectToPath
        )}`;

        return;
      }

      // TODO: ??
      if (desktopAction) {
        this.desktopSaveMode = true;
      }

      // go to setup
      if (idx === null) {
        this.goToSetup(0);
      } else {
        this.goToSetup(idx)
      }
    },
    inactiveSetup() {
      if (this.inactiveSetupFunc){
        this.inactiveSetupFunc();
        return;
      }

      this.activeSetupName = "";
      if (this.desktopSaveMode) this.desktopSaveMode = false;
    },
    processAPICatchError(e, callback = null) {
      // TODO: development模式 and production模式
      const errorMessage = HandleErrorResponse(e);
      if (!errorMessage) {
        return
      }

      swal({
        title: "提醒",
        text: errorMessage,
        dangerMode: true,
      }).then((_) => {
        if (callback) {
          callback();
        }
      });

    },
    notifyWhenLeaveProc(e) {
      if (this.notifyWhenLeave) {
        e.returnValue = "";
        e.preventDefault();
      }
    },
    notifyWhenLeaveClickProc(e) {
      if (this.notifyWhenLeave) {
        if (document.getElementById('js-design-lab').contains(e.target) || e.target.className.includes('swal')){
          console.log(e.target)
          console.log(e.target.href)
        }
        else{
          console.log(e.target.className)
          if (this.noClickBlock&&((e.target.className.includes('dropdown-item')||e.target.className.includes('desktop-menu-item')))||e.target.className.includes('is_mklink')||e.target.className.includes('menu-content-item'))
            {
            e.preventDefault();
            swal({
              title: "要離開網站嗎？",
              text: "系統可能不會儲存你所作的變更",
              buttons: {
                cancel:    { text: "Cancel",
                visible: true,
                value: false},
                confirm:  { text: "Ok",
                visible: true,
                value: true}
              },
              dangerMode: true,
              closeOnClickOutside: false
            }).then((x)=>{
              console.log( x)
              if (x){
                console.log(this.clickElement.target.parentElement)
                if (this.clickElement.target.href){
                  this.gotoURLNoNotify(this.clickElement.target.href)
                }else if (this.clickElement.target.parentElement.href){
                  this.gotoURLNoNotify(this.clickElement.target.parentElement.href)
                }else{

                }
              }

            })
          }
          this.clickElement=e
        }
      }
    },
    // 避免觸發離開提醒
    gotoURLNoNotify(url) {
      this.notifyWhenLeave = false;
      this.noClickBlock=false;
      window.location = url;
    },
    resetPreviewImages() {
      this.previewImages = this.previewerSideIds.map(_ => "");
      this.previewImages = this.design.moks.map((_) => "").concat(this.previewImages);
    },
    notifyDesignChanged() {
      this.canGetCheckInfo = true;
      this.notifyWhenLeave = true;
      this.designDirty     = true;
      this.noClickBlock=true;
    },
  },
});
